import { useTranslation } from "react-i18next";
import { ModalAddTag } from "@/features/modals";
import type { TagsFieldProps } from "../model";
import { useTagsField } from "../model";
import styles from "./styles.module.scss";
import { AddButton, Tag } from "./components";

export const TagsField = ({ selectedPersonId }: TagsFieldProps) => {
  const { t } = useTranslation();

  const { state, methods } = useTagsField(selectedPersonId);

  const { isModalOpen, fields, isLoading } = state;
  const { showModal, hideModal, onSubmit, remove } = methods;

  return (
    <div className={styles.root}>
      <div className={styles.tags}>
        {fields.map((tag, index) => (
          <Tag key={tag.id} onRemove={() => remove(index)} value={tag.name} loading={isLoading} />
        ))}
      </div>
      <AddButton onClick={showModal} loading={isLoading} />
      <ModalAddTag
        title={t("contactsPage.generalInfo.newTag")}
        open={isModalOpen}
        onClick={hideModal}
        onSubmit={onSubmit}
        onCancel={hideModal}
      />
    </div>
  );
};
